<template>
    <div>
        <mavon-editor :toolbarsFlag="false" :subfield="false" defaultOpen="preview" :navigation="false"
                      v-model="content" :codeStyle="markdown.codeStyle"/>
    </div>

</template>

<script>
    export default {
        name: "Wp_article_markdown",
        props: {
            content: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                contentMarkdown: '#标题' +
                    '##副标题' +
                    '###小标题',
                markdown: {
                    codeStyle: 'atom-one-dark',
                    toolbars: {
                        bold: true, // 粗体
                        italic: true, // 斜体
                        header: true, // 标题
                        underline: true, // 下划线
                        strikethrough: true, // 中划线
                        mark: true, // 标记
                        superscript: true, // 上角标
                        subscript: true, // 下角标
                        quote: true, // 引用
                        ol: true, // 有序列表
                        ul: true, // 无序列表
                        link: true, // 链接
                        imagelink: true, // 图片链接
                        code: true, // code
                        table: true, // 表格
                        fullscreen: true, // 全屏编辑
                        readmodel: true, // 沉浸式阅读
                        htmlcode: true, // 展示html源码
                        help: true, // 帮助
                        /* 1.3.5 */
                        undo: true, // 上一步
                        redo: true, // 下一步
                        trash: true, // 清空
                        save: true, // 保存（触发events中的save事件）
                        /* 1.4.2 */
                        navigation: true, // 导航目录
                        /* 2.1.8 */
                        alignleft: true, // 左对齐
                        aligncenter: true, // 居中
                        alignright: true, // 右对齐
                        /* 2.2.1 */
                        subfield: true, // 单双栏模式
                        preview: false, // 预览
                    }
                },
                markdownForm: {
                    articleId: null,
                    title: "",
                    contentMarkdown: '',
                    contentHtml: null,
                    type: 0
                },
            }
        },
        created() {
            this.loadContent();
        },
        methods: {
            loadContent() {
                let that = this;
                let _url = 'https://jd.wapg.cn/help/京东内购群常见问题解答/test.md';
                this.$get(_url).then(function (response) {
                    this.$log(response);
                    that.contentMarkdown = response;

                })
            }
        }
    }
</script>

<style scoped>
    .mavonEditor {
        width: 100%;
        height: 100%;
    }
</style>